import { render, staticRenderFns } from "./AudioBlock.vue?vue&type=template&id=550bc430&scoped=true"
import script from "./AudioBlock.vue?vue&type=script&lang=js"
export * from "./AudioBlock.vue?vue&type=script&lang=js"
import style0 from "./AudioBlock.vue?vue&type=style&index=0&id=550bc430&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550bc430",
  null
  
)

export default component.exports